import gsap from 'gsap';
import { Container, NineSlicePlane, Sprite, Text } from 'pixi.js';

import { Shared } from '../App';
import { Game } from '../game/Game';
import { Widget } from './Widget';

export class NicknameWidget extends Widget
{
    public game: Game;
    public content: Container;
    public bg: NineSlicePlane;
    public centered: Container;
    public flag: Sprite;
    public label: Text;

    constructor(game: Game)
    {
        super();
        this.game = game;

        this.content = new Container();
        this.view.addChild(this.content);

        this.bg = new NineSlicePlane(Shared.assets.getTexture('tt-valueholder-large'), 30, 10, 30, 10);
        this.content.addChild(this.bg);
        this.bg.width = 140;
        this.bg.x = -this.bg.width / 2;
        this.bg.y = -this.bg.height / 2;

        this.centered = new Container();
        this.content.addChild(this.centered);

        this.flag = new Sprite();
        this.flag.anchor.set(0, 0.5);
        this.centered.addChild(this.flag);
        this.flag.texture = Shared.assets.getTexture('flag-allstar-1');
        this.flag.width = 40;
        this.flag.scale.y = this.flag.scale.x;

        this.label = new Text('', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            align: 'left',
            fontSize: 20,
            stroke: 0x333333,
            strokeThickness: 7,
            lineJoin: 'round',
        });
        this.label.resolution = 2;
        this.label.y = -1;
        this.label.anchor.set(0, 0.5);
        this.centered.addChild(this.label);
    }

    protected async onOpen(): Promise<void>
    {
        this.refresh();
        gsap.killTweensOf(this.content);
        this.content.y = -300;
        await gsap.to(this.content, { y: 0, duration: 0.2, ease: 'expo.out' });
    }

    protected async onClose(): Promise<void>
    {
        this.refresh();
        gsap.killTweensOf(this.content);
        await gsap.to(this.content, { y: -300, duration: 0.2, ease: 'expo.in' });
    }

    public refresh(): void
    {
        if (!this._opened) return;

        this.label.text = Shared.user.data.vehicle.nickname;
        this.flag.texture = Shared.assets.getTexture(`flag-${Shared.user.data.vehicle.flag}`);
        this.flag.x = this.label.width + 2;
        this.centered.x = -this.centered.width / 2;
    }

    public async wobble(): Promise<void>
    {
        gsap.killTweensOf(this.content);
        gsap.to(this.content.scale, { x: 0.9, y: 1.3, duration: 0.1 });
        await gsap.to(this.content.scale, { x: 1, y: 1, duration: 1, ease: 'elastic.out', delay: 0.1 });
    }
}
